
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tecnologias/[slug]",
      function () {
        return require("private-next-pages/tecnologias/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tecnologias/[slug]"])
      });
    }
  